import { render, staticRenderFns } from "./PanelCallDetails.vue?vue&type=template&id=95d133a4"
import script from "./PanelCallDetails.vue?vue&type=script&lang=js"
export * from "./PanelCallDetails.vue?vue&type=script&lang=js"
import style0 from "./PanelCallDetails.vue?vue&type=style&index=0&id=95d133a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports